"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ensureDir(fileSystem, dir) {
    try {
        fileSystem.mkdir(dir);
    }
    catch (_a) {
        // ignore
    }
}
exports.ensureDir = ensureDir;
//# sourceMappingURL=utils.js.map